/**
 * Plateforme multi événement e.labriquerie.net, (c) Mikaël FOURNY.
 * src/i18n/fr.recadrage.ts
 *
 * Cadrage d'une photo de profil avant l'envoi (demande de Mika du
 * 2026-10-06) : déplacer, zoomer, valider ou annuler ; « Recadrer » une
 * photo déjà déposée. Fusionné dans fr.ts. Aucun nom d'événement écrit en
 * dur, apostrophe typographique partout.
 *
 * Mikael - chef de projet - 2026-10-06
 */
export const messagesRecadrageFr: Record<string, string> = {
  'recadrage.titre': 'Cadrer ma photo',
  'recadrage.consigne':
    'Faites glisser la photo pour placer le visage dans le rond, et zoomez si besoin (curseur, ou deux doigts sur téléphone).',
  'recadrage.zone.aria':
    'Photo à cadrer. Flèches pour la déplacer, touches plus et moins pour zoomer.',
  'recadrage.zoom': 'Zoom',
  'recadrage.valider': 'Valider',
  'recadrage.annuler': 'Annuler',
  'recadrage.chargement': 'Chargement de la photo…',
  'recadrage.erreur': 'Cette photo ne peut pas être lue. Essayez-en une autre.',
  'recadrage.recadrer': 'Recadrer',
  'recadrage.recadrer.erreur': 'La photo actuelle n’a pas pu être chargée pour la recadrer.',
};
